import React, { ReactElement } from 'react';
import { Flex } from '@cad-arc';
import { observer } from 'mobx-react-lite';
import { ContactListPanelBody } from '../contact-list/contact-list-panel';
import { FrPageHeader } from '../fr-page-layout/fr-page-header';
import { FrPage } from '../fr-page-layout/fr-page';
import { FrPageBody } from '../fr-page-layout/fr-page-body';

export const FrContactListPage = observer(function FrContactListPage(): ReactElement {
    return (
        <FrPage>
            <FrPageHeader title="Contact List" />
            <FrPageBody>
                <Flex flexDirection="column" w="100%" h="100%">
                    <ContactListPanelBody />
                </Flex>
            </FrPageBody>
        </FrPage>
    );
});
